var _style, _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserAvatar = function SvgUserAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65 65",
    style: {
      enableBackground: "new 0 0 65 65"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3164;enable-background:new    ;}\n\t.st1{fill:#238CF5;}\n\t.st2{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{opacity:0.1229;mask:url(#mask-2_1_);enable-background:new    ;}\n\t.st5{fill:#ABD1F9;}\n")), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 20")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23,50.7l-9.5,5.2c-0.6,0.3-1.1,0.7-1.5,1.1c5.6,4.7,12.8,7.5,20.6,7.5c7.8,0,14.9-2.8,20.5-7.4 c-0.5-0.4-1.1-0.8-1.7-1.1l-10.2-5.1c-1.3-0.7-2.2-2-2.2-3.5v-4c0.3-0.3,0.6-0.7,1-1.2c1.4-2,2.4-4.1,3.2-6.4 c1.3-0.4,2.3-1.6,2.3-3.1v-4.3c0-0.9-0.4-1.8-1.1-2.4v-6.2c0,0,1.3-9.6-11.8-9.6s-11.8,9.6-11.8,9.6V26c-0.7,0.6-1.1,1.4-1.1,2.4 v4.3c0,1.1,0.6,2.1,1.5,2.7c1.1,4.7,3.9,8,3.9,8v3.9C25,48.7,24.2,50,23,50.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 56.6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 56.6,
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_1_",
    className: "st3",
    points: "0.5,0.5 64.5,0.5 64.5,57.1 0.5,57.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3",
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33,0.5C15.4,0.2,0.8,14.3,0.5,32C0.3,42,4.8,51,11.9,57c0.5-0.4,1-0.8,1.5-1.1l9.5-5.2c1.3-0.7,2-2,2-3.4 v-3.9c0,0-2.8-3.4-3.9-8c-0.9-0.6-1.5-1.6-1.5-2.7v-4.3c0-0.9,0.4-1.8,1.1-2.4v-6.2c0,0-1.3-9.6,11.8-9.6s11.8,9.6,11.8,9.6V26 c0.7,0.6,1.1,1.4,1.1,2.4v4.3c0,1.4-1,2.7-2.3,3.1c-0.7,2.3-1.8,4.4-3.2,6.4c-0.4,0.5-0.7,0.9-1,1.2v4c0,1.5,0.8,2.8,2.2,3.5 L51.3,56c0.6,0.3,1.2,0.7,1.7,1.1c6.9-5.8,11.3-14.3,11.5-24C64.8,15.4,50.7,0.8,33,0.5"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M32.5,0C14.6,0,0,14.6,0,32.5S14.6,65,32.5,65C50.4,65,65,50.4,65,32.5S50.4,0,32.5,0z M32.5,64 C15.1,64,1,49.9,1,32.5C1,15.1,15.1,1,32.5,1S64,15.1,64,32.5C64,49.9,49.9,64,32.5,64z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user_avatar.3f3c808b.svg";
export { ForwardRef as ReactComponent };